import request from '@/utils/request';
export function fetchSchedulerNodes(params) {
  return request({
    url: '/admin/scheduler/node/page',
    method: 'get',
    params: params
  });
}
export function blockSchedulerNode(id) {
  return request({
    url: "/admin/scheduler/node/block/".concat(id),
    method: 'post'
  });
}
export function enableSchedulerNode(id) {
  return request({
    url: "/admin/scheduler/node/enable/".concat(id),
    method: 'post'
  });
}
export function deleteSchedulerNode(id) {
  return request({
    url: "/admin/scheduler/node/".concat(id),
    method: 'delete'
  });
}
export function updateSchedulerNodeWeight(id, weight) {
  return request({
    url: "/admin/scheduler/node/weight/".concat(id),
    method: 'post',
    data: {
      weight: weight
    }
  });
}